import React from 'react';
import { useTranslation } from 'react-i18next';
import { EditTeamMemberModalContent } from './content';
import { SimpleModal } from '@livable/saas-react-components';
export default function EditTeamMemberModal(_ref) {
  let isOpen = _ref.isOpen,
    data = _ref.data,
    handleClose = _ref.handleClose,
    handleEditModalSuccess = _ref.handleEditModalSuccess;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // NOTE: Edit team member

  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: null,
    isOpen: isOpen,
    handleClose: handleClose,
    title: t('team_page.edit_team_member'),
    noFooter: true,
    noPadding: true
  }, /*#__PURE__*/React.createElement(EditTeamMemberModalContent, {
    data: data,
    handleEditModalSuccess: handleEditModalSuccess
  }));
}